import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/store';

export function Chatbot() {
  const userProfile = useSelector((state: RootState) => state.userProfile);

  useEffect(() => {
    const existing = document.getElementById('chatvolt-host');
    if (existing) return;

    // Create host + Shadow Root
    const host = document.createElement('div');
    host.id = 'chatvolt-host';
    document.body.appendChild(host);
    const shadowRoot = host.attachShadow({ mode: 'open' });

    // Create a container inside the Shadow DOM
    const container = document.createElement('div');
    container.id = 'rootChatVolt';
    shadowRoot.appendChild(container);

    // Attach user info in a dataset attribute
    container.dataset.userInfo = JSON.stringify({
      url: '',
      userName: userProfile.username,
      userEmail: userProfile.email
    });

    // Load CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://chat.sbx.solaris-pulse.com/static/css/main.css';
    shadowRoot.appendChild(link);

    // Load ChatVolt script once
    const script = document.createElement('script');
    script.src = 'https://chat.sbx.solaris-pulse.com/static/js/main.js';
    script.async = true;
    shadowRoot.appendChild(script);

    // Set the mount point
    (window as any).__chatVoltMountPoint__ = container;

    // Cleanup on unmount
    return () => {
      host.remove();
      delete (window as any).__chatVoltMountPoint__;
    };
  }, [userProfile.username, userProfile.email]);

  return null;
}
